import React from "react";

const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-6">
      {/* SVG icon */}
      <svg
        className="w-16 h-16 text-gray-500 mb-4"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 4.75V2m0 20v-2.75m7.07-7.07H22m-20 0h2.93m14.14-4.24l1.94-1.94M4.93 19.07l1.94-1.94M19.07 19.07l-1.94-1.94M4.93 4.93L6.87 6.87"
        />
        <circle cx="12" cy="12" r="3" />
      </svg>

      {/* Text content */}
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Coming Soon</h1>
      <p className="text-gray-600 max-w-md">
        We're updating this category with amazing products. Visit again shortly!
      </p>
    </div>
  );
};

export default ComingSoon;
